import { render, staticRenderFns } from "./LeaderTile.vue?vue&type=template&id=73c32123&scoped=true&"
import script from "./LeaderTile.vue?vue&type=script&lang=js&"
export * from "./LeaderTile.vue?vue&type=script&lang=js&"
import style0 from "./LeaderTile.vue?vue&type=style&index=0&id=73c32123&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c32123",
  null
  
)

export default component.exports